import { css } from "@compiled/react";

import Lozenge from "@atlaskit/lozenge";
import { getColor } from "@atlassiansox/wpl-utils";

import { Icon } from "@/libraries/wpl/foundations/src/icon";
import { LinkModal } from "@/patterns/modal/src";

import { PlanFeatureMessage } from "../constants";

const planFeatureMessageContainerStyles = css({
    display: "flex",
    paddingInlineStart: "18px",
    paddingBlockStart: "16px",
    button: {
        "background": "none",
        "border": "none",
        "color": getColor("b300"),
        "cursor": "pointer",
        "fontFamily": "Charlie Text",
        "fontSize": "16px",
        "fontWeight": 400,
        "paddingLeft": "4px",
        "textAlign": "left",
        "textDecoration": "underline",
        "textDecorationStyle": "dashed",
        "textDecorationThickness": "1px",
        "textUnderlineOffset": "3px",
        ":hover": {
            color: getColor("b500")
        }
    }
});

const noModalFeatureStyles = css({
    color: getColor("n900"),
    paddingInlineStart: "4px"
});

const PlanFeature = ({ featureMessage, lozengeText }: PlanFeatureMessage) => {
    const isLinkPropsType = !(typeof featureMessage === "string");

    return (
        <div css={planFeatureMessageContainerStyles}>
            <Icon name="featurecheckmark" size="xs" color="g400" />

            <div css={noModalFeatureStyles}>
                {isLinkPropsType ? (
                    <LinkModal {...featureMessage} />
                ) : (
                    featureMessage
                )}
                {lozengeText && <Lozenge>{lozengeText}</Lozenge>}
            </div>
        </div>
    );
};

export { PlanFeature };
